function Icon({ color = "#5C6569" }: { color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M14.707 14.707a1 1 0 01-1.414 0l-2.387-2.387a6.25 6.25 0 111.414-1.414l2.387 2.387a1 1 0 010 1.414zM7.25 3a4.25 4.25 0 100 8.5 4.25 4.25 0 000-8.5z"
      ></path>
    </svg>
  );
}

export default Icon;
